<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限制状态" :value="0"></el-option>
                        <el-option label="仅看正常的" :value="1"></el-option>
                        <el-option label="仅看屏蔽的" :value="2"></el-option>
                        <el-option label="仅看被举报的" :value="3"></el-option>
                        <el-option label="仅看被用户删除的" :value="-1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.articleId" placeholder="请输入评论对象ID" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="评论时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                        ></el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span :class="{'color-success': scope.row.status == 1}">{{ status.get(scope.row.status) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isReport" label="是否被举报" min-width="90">
                    <template slot-scope="scope">
                        <span :class="{'color-danger': scope.row.isReport == 1}">{{ scope.row.isReport == 1 ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createUserId" label="评论用户ID" min-width="90"></el-table-column>
                <el-table-column prop="createUserName" label="评论用户昵称" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column prop="content" label="评论内容" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="createTime" label="评论时间" min-width="150"></el-table-column>
                <el-table-column prop="articleId" label="评论对象ID" min-width="90"></el-table-column>
                <el-table-column prop="articleName" label="评论对象昵称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="modifyUserName" label="最后操作人" show-overflow-tooltip></el-table-column>
                
                <el-table-column fixed="right" label="操作" width="140">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/article/review/info')"
                            type="text"
                            size="small"
                            icon="el-icon-s-comment"
                            @click="view(scope.row.id)"
                        >
                            回复
                        </el-button>
                        <template v-if="$utils.have('/article/review/updateStatus')">
                            <el-button
                                v-if="scope.row.status == 0"
                                type="text"
                                size="small"
                                icon="el-icon-circle-check"
                                @click="editStatus(scope.row.id, 1)"
                            >
                                开放
                            </el-button>
                            <el-button
                                v-else-if="scope.row.status == 1"
                                type="text"
                                size="small"
                                icon="el-icon-remove-outline"
                                @click="editStatus(scope.row.id, 0)"
                            >
                                屏蔽
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    articleId: '',
    type: 0,
    startTime: '',
    endTime: '',
    timeType: 1
};
export default {
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                articleId: this.$route.query.articleId || '',
                type: parseInt(this.$route.query.type || 0)
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
        };
    },
    computed: {
        status() {
            return new Map([
                [-1, '删除'],
                [0, '屏蔽'],
                [1, '正常']
            ]);
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: (this.datetimerange && this.datetimerange[0]) || '',
                endTime: (this.datetimerange && this.datetimerange[1]) || ''
            };
            this.listLoading = true;
            this.$request({
                url: '/article/review/pageList',
                method: 'POST',
                data: {
                    ...this.params
                }
            })
                .then(res => {
                    const {state, msg, result} = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize
            };
            this.getDataList();
        },
        //编辑状态
        editStatus(id, status) {
            const _msg = status == 1 ? '确定要开放吗?' : '确定要屏蔽吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/article/review/updateStatus',
                    method: 'POST',
                    params: {id: id, status: status}
                })
                    .then(res => {
                        const {state, msg} = res.data;
                        if (state == 1) {
                            let timer = setTimeout(() => {
                                this.getDataList();
                                clearTimeout(timer);
                            }, 500);
                        } else {
                            this.$message.error(msg || '请求失败');
                            this.listLoading = false;
                        }
                    })
                    .catch(() => {
                        this.$message.error('请求错误');
                        this.listLoading = false;
                    })
                    .finally(() => {
                        // this.listLoading = false;
                    });
            });
        },
        view(id){
            this.$router.push({
                path: `/dynamic/review/detail/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params,
                        }
                    ),
                },
            });
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
